import axios from "../../../utilities/axios";
import {MeDto} from "../../../models/dtos/me.dto";
import {AnswerRequest} from "../../../models/requests/answer.request";

export const answerQuestionRequest = async (request: AnswerRequest): Promise<MeDto> => {
  try {
    const response = await axios.post<MeDto>(
      `${process.env.REACT_APP_BASE_URL}/users/questions/answer`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}